import React from 'react';
import PropTypes from 'prop-types';
import { getTokensPropType, selectSystemProps, variantProp } from '@telus-uds/components-base';
import styled from 'styled-components';
import { htmlAttrs } from '../utils';
import OrderedListBase from './OrderedListBase';
import Item from './Item';
import { OL_COUNTER_NAME } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const [selectProps, selectedSystemPropTypes] = selectSystemProps([htmlAttrs]);
const StyledOrderedListBase = /*#__PURE__*/styled(OrderedListBase).withConfig({
  displayName: "OrderedList__StyledOrderedListBase",
  componentId: "components-web__sc-t5az8z-0"
})(_ref => {
  let {
    start
  } = _ref;
  return {
    // Using CSS counters here to have better control over the number styling
    listStyle: 'none',
    counterReset: `${OL_COUNTER_NAME} ${start - 1}`
  };
});

/**
 * Themed semantic ordered list.
 */
const OrderedList = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    children,
    start = 1,
    variant = {},
    tokens = {},
    ...rest
  } = _ref2;
  // Check if children is an array
  const isChildrenArray = Array.isArray(children);

  // Pass any variants and tokens "OrderedList" receives down to the individual list items.
  const childrenWithParentVariantsAndTokens = React.useMemo(() => {
    const addVariantAndTokensToProps = child => {
      const existingChildVariants = child.props?.variant ?? {};
      const existingChildTokens = child.props?.tokens ?? {};
      return /*#__PURE__*/React.cloneElement(child, {
        variant: {
          ...existingChildVariants,
          ...variant
        },
        tokens: {
          ...existingChildTokens,
          ...tokens
        }
      });
    };
    if (variant || tokens) {
      if (isChildrenArray) {
        return children.map(addVariantAndTokensToProps);
      }
      return [addVariantAndTokensToProps(children)];
    }
    return children;
  }, [children, variant, isChildrenArray, tokens]);
  return /*#__PURE__*/_jsx(StyledOrderedListBase, {
    ...selectProps(rest),
    ref: ref,
    start: start,
    children: childrenWithParentVariantsAndTokens
  });
});
OrderedList.displayName = 'OrderedList';
OrderedList.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * A list of ordered items wrapped in `OrderedList.Item`.
   */
  children: PropTypes.node.isRequired,
  /**
   * The position to start the list with.
   */
  start: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  variant: variantProp.propType,
  tokens: getTokensPropType('OrderedList')
};
OrderedList.Item = Item;
export default OrderedList;